import React, { useEffect, useState } from "react";
import { getEmployeeProfile } from "../../api/employeeApi";

import "../../css/CustomTable.css";

export default function Profile() {
  const [profile, setProfile] = useState(null);
  const employeeCode = sessionStorage.getItem("username");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const profileData = await getEmployeeProfile(employeeCode);
      setProfile(profileData.data || profileData);
    } catch (error) {
      console.error("Failed to fetch employee details", error);
    }
  };

  return (
    <div className="container-fluid p-1">
      {/* <h4 className="allowance-heading">Home</h4> */}

      {/* <h4 className="allowance-heading">Employee Details</h4> */}
      <div className="allowance-table-container">
        <table className="allowance-table">
          <thead>
            <tr>
              <th colSpan="4" className="text-center">
                My Profile
              </th>
            </tr>
          </thead>
          <tbody>
            {profile ? (
              <>
                <tr>
                  <td>Employee Code</td>
                  <td>{profile.employeeCode}</td>
                  <td>Employee Name</td>
                  <td>
                    {profile.fName} {profile.mName} {profile.lName}
                  </td>
                </tr>
                <tr>
                  <td>Father/Husband Name</td>
                  <td>{profile.fatherHusbandName}</td>
                  <td>Name on Aadhar</td>
                  <td>{profile.nameOnAadharCard}</td>
                </tr>
                <tr>
                  <td>Birth Date</td>
                  <td>{profile.birthDate?.split("T")[0]}</td>
                  <td>Gender</td>
                  <td>{profile.gender || "N/A"}</td>
                </tr>
                <tr>
                  <td>Email ID</td>
                  <td>{profile.emailId}</td>
                  <td>Permanent Address</td>
                  <td>{profile.permanentAddress}</td>
                </tr>
                <tr>
                  <td>Aadhar Card Number</td>
                  <td>{profile.aadharCardNumber}</td>
                  <td>PAN No</td>
                  <td>{profile.panNo}</td>
                </tr>
                <tr>
                  <td>IFSC Code</td>
                  <td>{profile.ifscCode}</td>
                  <td>Bank Account No</td>
                  <td>{profile.bankAccountNo}</td>
                </tr>
                <tr>
                  <td>Joining Date</td>
                  <td>{profile.joiningDate?.split("T")[0]}</td>
                  <td>Department</td>
                  <td>{profile.departmentName}</td>
                </tr>
                <tr>
                  <td>Designation</td>
                  <td>{profile.designationName}</td>
                  <td>Section And Grade</td>
                  <td>
                    {profile.sectionName} and {profile.gradeName}
                  </td>
                </tr>
                <tr>
                  <td>PF Account No</td>
                  <td>{profile.pfAccountNo}</td>
                  <td>ESIC No</td>
                  <td>{profile.esicNo}</td>
                </tr>
              </>
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  Loading or no data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
     </div>
    );
}




// import React, { useEffect, useState } from "react";
// import { getEmployeeProfile } from "../../api/employeeApi";
// import "../../css/CustomTable.css";

// export default function Profile() {
//   const [profile, setProfile] = useState(null);
//   const employeeCode = sessionStorage.getItem("username");

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const profileData = await getEmployeeProfile(employeeCode);
//       setProfile(profileData.data || profileData);
//     } catch (error) {
//       console.error("Failed to fetch employee details", error);
//     }
//   };

//   return (
//     <div className="container py-3">
//       <h4 className="text-center mb-4 text-danger fw-bold">Employee Details</h4>

//       {profile ? (
//         <div className="card shadow-sm p-3">
//           <div className="row">
//             <div className="col-md-6 mb-2">
//               <strong>Employee Name:</strong> {profile.fName} {profile.mName} {profile.lName}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>Employee Code:</strong> {profile.employeeCode}
//             </div>

//             <div className="col-md-6 mb-2">
//               <strong>Father/Husband Name:</strong> {profile.fatherHusbandName}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>Name on Aadhar:</strong> {profile.nameOnAadharCard}
//             </div>

//             <div className="col-md-6 mb-2">
//               <strong>Birth Date:</strong> {profile.birthDate?.split("T")[0]}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>Gender:</strong> {profile.gender || "N/A"}
//             </div>

//             <div className="col-md-6 mb-2">
//               <strong>Email ID:</strong> {profile.emailId}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>Permanent Address:</strong> {profile.permanentAddress}
//             </div>

//             <div className="col-md-6 mb-2">
//               <strong>Aadhar Card Number:</strong> {profile.aadharCardNumber}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>PAN No:</strong> {profile.panNo}
//             </div>

//             <div className="col-md-6 mb-2">
//               <strong>IFSC Code:</strong> {profile.ifscCode}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>Bank Account No:</strong> {profile.bankAccountNo}
//             </div>

//             <div className="col-md-6 mb-2">
//               <strong>Joining Date:</strong> {profile.joiningDate?.split("T")[0]}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>Department:</strong> {profile.departmentName}
//             </div>

//             <div className="col-md-6 mb-2">
//               <strong>Designation:</strong> {profile.designationName}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>Section & Grade:</strong> {profile.sectionName} and {profile.gradeName}
//             </div>

//             <div className="col-md-6 mb-2">
//               <strong>PF Account No:</strong> {profile.pfAccountNo}
//             </div>
//             <div className="col-md-6 mb-2">
//               <strong>ESIC No:</strong> {profile.esicNo}
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="text-center">Loading or no data found.</div>
//       )}
//     </div>
//   );
// }




// import React, { useEffect, useState } from "react";
// import { getEmployeeProfile } from "../../api/employeeApi";
// import "../../css/CustomTable.css";

// export default function Profile() {
//   const [profile, setProfile] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const employeeCode = sessionStorage.getItem("username");

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const profileData = await getEmployeeProfile(employeeCode);
//       setProfile(profileData.data || profileData);
//     } catch (error) {
//       console.error("Failed to fetch employee details", error);
//     }
//   };

//   const handleChange = (e) => {
//     setProfile({ ...profile, [e.target.name]: e.target.value });
//   };

//   const handleEditToggle = () => {
//     setIsEditing(!isEditing);
//   };

//   const handleSave = () => {
//     // later: call API to update employee details
//     console.log("Updated Profile:", profile);
//     setIsEditing(false);
//   };

//   return (
//     <div className="container py-3">
//       <h4 className="text-center mb-4 text-danger fw-bold">Employee Profile</h4>

//       {profile ? (
//         <div className="card shadow-sm p-3">
//           <div className="row">
//             {[
//               { label: "Employee Name", name: "fName", value: `${profile.fName} ${profile.mName} ${profile.lName}` },
//               { label: "Employee Code", name: "employeeCode", value: profile.employeeCode },
//               { label: "Father/Husband Name", name: "fatherHusbandName", value: profile.fatherHusbandName },
//               { label: "Name on Aadhar", name: "nameOnAadharCard", value: profile.nameOnAadharCard },
//               { label: "Birth Date", name: "birthDate", value: profile.birthDate?.split("T")[0] },
//               { label: "Gender", name: "gender", value: profile.gender || "N/A" },
//               { label: "Email ID", name: "emailId", value: profile.emailId },
//               { label: "Permanent Address", name: "permanentAddress", value: profile.permanentAddress },
//               { label: "Aadhar Card Number", name: "aadharCardNumber", value: profile.aadharCardNumber },
//               { label: "PAN No", name: "panNo", value: profile.panNo },
//               { label: "IFSC Code", name: "ifscCode", value: profile.ifscCode },
//               { label: "Bank Account No", name: "bankAccountNo", value: profile.bankAccountNo },
//               { label: "Joining Date", name: "joiningDate", value: profile.joiningDate?.split("T")[0] },
//               { label: "Department", name: "departmentName", value: profile.departmentName },
//               { label: "Designation", name: "designationName", value: profile.designationName },
//               { label: "Section & Grade", name: "sectionName", value: `${profile.sectionName} and ${profile.gradeName}` },
//               { label: "PF Account No", name: "pfAccountNo", value: profile.pfAccountNo },
//               { label: "ESIC No", name: "esicNo", value: profile.esicNo }
//             ].map((field, idx) => (
//               <div className="col-md-6 mb-3" key={idx}>
//                 <label className="fw-bold">{field.label}</label>
//                 <input
//                   type="text"
//                   name={field.name}
//                   value={field.value}
//                   onChange={handleChange}
//                   className="form-control"
//                   disabled={!isEditing}
//                 />
//               </div>
//             ))}
//           </div>

//           <div className="text-end">
//             {isEditing ? (
//               <>
//                 <button className="btn btn-success btn-sm me-2" onClick={handleSave}>
//                   Save
//                 </button>
//                 <button className="btn btn-secondary btn-sm" onClick={handleEditToggle}>
//                   Cancel
//                 </button>
//               </>
//             ) : (
//               <button className="btn btn-primary btn-sm" onClick={handleEditToggle}>
//                 Edit
//               </button>
//             )}
//           </div>
//         </div>
//       ) : (
//         <div className="text-center">Loading or no data found.</div>
//       )}
//     </div>
//   );
// }
